import Vue from 'vue'
import VueX from 'vuex'

Vue.use(VueX)

export default new VueX.Store({
  state: {
    unit: [],
  },
  mutations: {
    SET_UNIT(state, unit) {
      state.unit = unit
    },
  },
  actions: {
    setUnit({ commit }, unit) {
      commit('SET_UNIT', unit)
    },
  },
  getters: {
    getUnitByText: (state) => (text) => {
      return state.unit.filter((val) => val.text === text)[0]
    },
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js